import { Column } from '../objects/column';
import { Preferences } from '../../profile/objects/preferences';
import { ListPreferenceResult, setListPreference } from '../../utils/list/utils/setListPreference';

export const PROVIDER_MODULE = 'PROVIDER';

export const DEFAULT_PROVIDER_COLUMNS: Column[] = [{
    label: 'provider-name',
    field_name: 'PROVIDER_NAME',
    checked: true,
    order_by: 'provider__name',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'content-types',
    field_name: 'CONTENT_TYPE',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'created-date',
    field_name: 'CREATED_DATE',
    checked: false,
    order_by: 'created_date',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'created-by',
    field_name: 'CREATED_BY',
    checked: false,
    order_by: 'creator__username',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'modified-date',
    field_name: 'MODIFIED_DATE',
    checked: true,
    order_by: 'modified_date',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'modified-by',
    field_name: 'MODIFIED_BY',
    checked: true,
    order_by: 'last_author__username',
    fixed_width: true,
    last_updated: false,
    width: null
}];

export const setProviderPreference = (prefs: Preferences[], cols: Column[]): ListPreferenceResult =>
    setListPreference(prefs, cols, { module: PROVIDER_MODULE, default_columns: DEFAULT_PROVIDER_COLUMNS, default_order_by: 'name', default_order: 'asc' });
